import { ClearOutlined, CloseOutlined, DeleteOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Drawer, Grid, Input, Row, Tooltip } from 'antd';
import React, { useEffect, useRef } from 'react';
import styles from './style.module.scss';
import { get_and_search_jobs } from '../../features/Jobseeker/jobseekerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setOnsearchValues, setSearchParameters } from '../../features/Global/globalSlice';
import { getAuthToken } from '../../utils/authHelpers';
import { onClearGlobalSearchData, setGlobalLocationText, setGlobalSearchNameText, setIsGlobalSearchOpen, setLocationSearchText, setNameSearchText, setSearchSummary } from '../../features/Global/FiltersSearchSlice';
import { setIsFilledGlobalSearch } from '../../features/UserInfo/UserSlice';

const { useBreakpoint } = Grid;

const GlobalSearch = () => {
  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getAuthToken();
  const { GlobalSearchLocationText, GlobalSearchNameText, isGlobalSearch,
    searchSummary, storeAppliedFilters } = useSelector((state) => state.filterSearch);

  const jobNameRef = useRef(null);
  const locationRef = useRef(null);

  const showDrawer = () => {
    dispatch(setIsGlobalSearchOpen(true));
  };

  const onClose = () => {
    dispatch(setIsGlobalSearchOpen(false));
  };

  const onSearchData = () => {
    const searchString = GlobalSearchNameText;
    const jobLocation = GlobalSearchLocationText;

    const payload = {
      searchString,
      jobLocation
    };

    dispatch(setOnsearchValues(payload));
    dispatch(setNameSearchText(searchString));
    dispatch(setLocationSearchText(jobLocation));
    const filteredValues = {};

    if (searchString && searchString?.trim() !== "") {
      filteredValues.searchString = searchString?.trim();
    }

    if (jobLocation && jobLocation.trim() !== "") {
      filteredValues.jobLocation = jobLocation.trim();
    }
    if (storeAppliedFilters && Object.keys(storeAppliedFilters).length > 0) {
      Object.entries(storeAppliedFilters).forEach(([key, value]) => {
        if (typeof value === 'string' && value.trim() !== "") {
          filteredValues[key] = value.trim();
        } else if (value != null && value !== '') {
          filteredValues[key] = value;
        }
      });
    }

    const searchParams = new URLSearchParams();
    Object.entries(filteredValues).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          searchParams.append(key, val);
        });
      } else {
        searchParams.append(key, value);
      }
    });

    const finalSearchString = searchParams.toString();

    if (finalSearchString) {
      const navigationPage = token ? '/searched-jobs' : '/jobseeker';

      const summary = [filteredValues.searchString, filteredValues.jobLocation]
        .filter(Boolean)
        .join(', ');

      dispatch(setSearchSummary(summary || 'Search Jobs here'));
      dispatch(setSearchParameters(finalSearchString));
      dispatch(get_and_search_jobs({ navigate, searchParams: finalSearchString }));
      navigate(navigationPage);
    }

    dispatch(setIsGlobalSearchOpen(false));
  };

  const clearSearch = () => {
    dispatch(onClearGlobalSearchData());

    const filtersToKeep = { ...storeAppliedFilters };
    delete filtersToKeep.searchString;
    delete filtersToKeep.jobLocation;

    const searchParams = new URLSearchParams();

    Object.entries(filtersToKeep).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => searchParams.append(key, val));
      } else {
        searchParams.append(key, value);
      }
    });

    dispatch(get_and_search_jobs({ navigate, searchParams: searchParams.toString() }));
    onClose()
  };

  useEffect(() => {
    if (isGlobalSearch) {
      setTimeout(() => {
        jobNameRef.current?.focus();
      }, 100);
    }
  }, [isGlobalSearch]);

  const handleEditClick = () => {
    if (GlobalSearchLocationText && !GlobalSearchNameText) {
      locationRef.current?.focus();
    } else if (!GlobalSearchLocationText && GlobalSearchNameText) {
      jobNameRef.current?.focus();
    } else if (GlobalSearchLocationText && GlobalSearchNameText) {
      jobNameRef.current?.focus();
    }
    dispatch(setIsGlobalSearchOpen(true));
  };

  const isFilled = GlobalSearchNameText || GlobalSearchLocationText;
  dispatch(setIsFilledGlobalSearch(isFilled))

  const handleChangeName = (e) => {
    dispatch(setGlobalSearchNameText(e.target.value));
  };

  const handleChangeLocation = (e) => {
    dispatch(setGlobalLocationText(e.target.value));
  };

  return (
    <div>
      {isFilled ? (
        // <Input
        //   onClick={showDrawer}
        //   className="fullwidth"
        //   size="middle"
        //   value={searchSummary}
        //   readOnly
        //   suffix={
        //     <div style={{ display: 'flex', gap: '8px' }}>
        //       {searchSummary !== 'Search Jobs here' && (
        //         <Tooltip title="Clear">
        //           <Avatar
        //             onClick={clearSearch}
        //             className="error-bg add-cursor"
        //             size={25}
        //             icon={<DeleteOutlined />}
        //           />
        //         </Tooltip>
        //       )}
        //       {isFilled ? (
        //         <Tooltip title="Edit">
        //           <Avatar
        //             onClick={handleEditClick}
        //             className="default-button-style add-cursor"
        //             size={25}
        //             icon={<EditOutlined />}
        //           />
        //         </Tooltip>
        //       ) : (
        //         <Tooltip title="Search">
        //           <Avatar
        //             onClick={showDrawer}
        //             className="blueGradiant add-cursor"
        //             size={25}
        //             icon={<SearchOutlined />}
        //           />
        //         </Tooltip>
        //       )}
        //     </div>
        //   }
        // />
        <>
          <Tooltip title="Search">
            <Avatar
              onClick={showDrawer}
              className={`blueGradiant add-cursor ${styles.editremoveGlobal}`}
              size={30}
              icon={<SearchOutlined />}
            />
          </Tooltip>
        </>

      ) :
        (
          <Tooltip title="Search">
            <Avatar
              onClick={showDrawer}
              className={`blueGradiant add-cursor ${styles.editremoveGlobal}`}
              size={30}
              icon={<SearchOutlined />}
            />
          </Tooltip>
        )}
      <div>
        <Drawer
          title={<div className='btnfonts'>Search Jobs</div>}
          placement="top"
          closable={false}
          extra={<Avatar onClick={onClose} className='darkGradiant text-white add-cursor' size={'small'} icon={<CloseOutlined />} />}
          onClose={onClose}
          open={isGlobalSearch}
          key="top"
          height={screens.lg || screens.md ? '20%' : '40%'}
          className={`green-box-shadow ${styles.antDrawerHeader}`}
        >
          <Row justify={'center'} gutter={[16, 16]}>
            <Col xs={24} lg={9} md={9} >

              <Input
                ref={jobNameRef}
                size="middle"
                className={`small-paragraphs ${styles.formItem}`}
                placeholder="Search Designation / Company etc..."
                value={GlobalSearchNameText || ''}
                onChange={handleChangeName}
                name='searchString'
              />

            </Col>
            <Col xs={24} lg={9} md={9}>
              <Input
                ref={locationRef}
                size="middle"
                className={`small-paragraphs ${styles.formItem}`}
                placeholder="Search by Location"
                value={GlobalSearchLocationText || ''}
                onChange={handleChangeLocation}
              />
            </Col>
            <Col xs={24} lg={3} md={3}>
              {isFilled ?
                <div className='flex-space-between-gap-5'>
                  <Button
                    htmlType="submit"
                    shape="round"
                    size="middle"
                    className="fullwidth default-button-style btnfonts"
                    onClick={onSearchData}
                  >
                    Search
                  </Button>
                  <Button
                    danger
                    htmlType="submit"
                    shape="round"
                    size="middle"
                    type='primary'
                    className="fullwidth btnfonts"
                    onClick={clearSearch}
                  >
                    Clear
                  </Button>
                </div>

                :
                <Button
                  htmlType="submit"
                  shape="round"
                  size="middle"
                  className="fullwidth default-button-style btnfonts"
                  onClick={onSearchData}
                >
                  Search
                </Button>}
            </Col>
          </Row>
        </Drawer>
      </div>
    </div>
  );
};

export default GlobalSearch;

